module.exports = "<i class=material-icons (click)=toggleFullScreen($event)>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen'}}</i> ";